exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-650af06e],.fade-leave-active[data-v-650af06e]{transition:opacity .5s}.fade-enter[data-v-650af06e],.fade-leave-to[data-v-650af06e]{opacity:0}", ""]);

// exports
